import {
  listMembershipQuestions as publicListMembershipQuestions,
  createOrReplaceAllMembershipQuestions as publicCreateOrReplaceAllMembershipQuestions,
  listAnswers as publicListAnswers,
} from './social-groups-v2-membership-question-membership-questions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listMembershipQuestions: MaybeContext<
  BuildRESTFunction<typeof publicListMembershipQuestions> &
    typeof publicListMembershipQuestions
> = /*#__PURE__*/ createRESTModule(publicListMembershipQuestions);
export const createOrReplaceAllMembershipQuestions: MaybeContext<
  BuildRESTFunction<typeof publicCreateOrReplaceAllMembershipQuestions> &
    typeof publicCreateOrReplaceAllMembershipQuestions
> = /*#__PURE__*/ createRESTModule(publicCreateOrReplaceAllMembershipQuestions);
export const listAnswers: MaybeContext<
  BuildRESTFunction<typeof publicListAnswers> & typeof publicListAnswers
> = /*#__PURE__*/ createRESTModule(publicListAnswers);

export {
  MembershipQuestion,
  ListMembershipQuestionsRequest,
  ListMembershipQuestionsResponse,
  CreateOrReplaceAllMembershipQuestionsRequest,
  CreateOrReplaceAllMembershipQuestionsResponse,
  ListAnswersRequest,
  Paging,
  ListAnswersResponse,
  MemberMembershipQuestionAnswers,
  MembershipQuestionAnswer,
  PagingMetadata,
  ListAnswerCountsRequest,
  ListAnswerCountsResponse,
  MemberAnswerCount,
  CreateOrReplaceAllMembershipQuestionsOptions,
  ListAnswersOptions,
} from './social-groups-v2-membership-question-membership-questions.universal.js';
